module.exports = __webpack_public_path__ + "static/media/contact_card_green.4d460823.svg";